export default __webpack_public_path__ + "static/media/exitFullscreen.c0a0479f.svg";